import React from "react";
import { Box, Flex, Text } from "@chakra-ui/react";
import { Page } from "components/page";
import { Section } from "components/section";
import { type NextPage } from "next";
import Image from "next/image";
import { Link } from "ui/link";
import PrivacyChoicesIcon from "../../public/assets/privacy/privacy-choices.svg";

const PrivacyChoices: NextPage = () => {
  return (
    <Page
      title="Your privacy choices"
      description="Hightouch provides consumers with various rights with respect to their personal information."
      footerOptions={{ hideCta: true }}
    >
      <Section maxW="4xl" mx="auto" my="0" py={{ base: 12, md: 16 }}>
        <Flex mb={{ base: 4, md: 8 }} alignItems="center" width="100%" justifyContent="center" gap={4}>
          <Text as="h1" textStyle="h5">
            Your privacy choices
          </Text>
          <Image
            src={PrivacyChoicesIcon}
            alt="California Consumer Privacy Act (CCPA) Opt-Out Icon"
            width={40}
            height={40}
          />
        </Flex>
        <Text>
          Hightouch provides consumers with various rights with respect to their personal information. This includes the
          right to request the deletion of their personal information (“Right to Delete”) and the right to opt out from
          the sale of their personal information (“Opt Out Request”).
        </Text>

        <Box w="100%" borderRadius="md" border="1px solid" mt={8}>
          <iframe
            width="100%"
            height="800px"
            src="https://docs.google.com/forms/d/e/1FAIpQLScPpV78KGxG4L_w32GqWYLo8CgSt7RGESYmiUI2Ni5-yne9KA/viewform?embedded=true"
          />
        </Box>
        <Box mt={8}>
          <Text>
            Manage your cookie preferences{" "}
            <Link
              onClick={() => {
                window?.OneTrust.ToggleInfoDisplay(); // eslint-disable-line new-cap
              }}
            >
              here
            </Link>
            .
          </Text>
        </Box>
      </Section>
    </Page>
  );
};

export default PrivacyChoices;
